// Mirrors the backend Core.DomainModels.Risk.RiskAssessmentStatus enum (numeric, stored as INT).
export enum RiskAssessmentStatus {
    Unscored = 1,
    Active = 2,
    Retired = 3,
}

export const riskAssessmentStatusTranslationKey: Record<RiskAssessmentStatus, string> = {
    [RiskAssessmentStatus.Unscored]: "riskAssessmentStatusUnscored",
    [RiskAssessmentStatus.Active]: "riskAssessmentStatusActive",
    [RiskAssessmentStatus.Retired]: "riskAssessmentStatusRetired",
};

// The default-visible set on the assessment overview — retired assessments are hidden until the user
// opts in via the Status filter.
export const nonRetiredStatuses: Array<RiskAssessmentStatus> = [RiskAssessmentStatus.Unscored, RiskAssessmentStatus.Active];

export const allRiskAssessmentStatuses: Array<RiskAssessmentStatus> = [
    RiskAssessmentStatus.Unscored,
    RiskAssessmentStatus.Active,
    RiskAssessmentStatus.Retired,
];
